var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isAuthenticated)?_c('Hook',{on:{"created":function($event){return _vm.authenticatedChanged()},"beforeDestroy":function($event){return _vm.authenticatedChanged()}}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }